<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.type === 'edit' ? $t('scope.text_710') : $t('common.action.create') }}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('report.field_name')" prop="name">
          <a-input v-model="form.name" :placeholder="$t('common.tips.input', [$t('report.field_name')])" />
        </a-form-model-item>
        <a-form-model-item :label="$t('report.field_type')" prop="value_type" :extra="form.value_type === '6' ? $t('report.field_enume_extra') : ''">
          <base-select
            v-model="form.value_type"
            :options="valueTypeOpts"
            :select-props="{placeholder: $t('common.tips.select', [$t('report.field_type')])}"
            :disabled="params.formType === 'edit' && params.data.id"
            @change="handleValueTypeChange" />
        </a-form-model-item>
        <a-form-model-item :label="$t('report.field_setting')" v-if="!isEnume">
          <a-checkbox-group v-model="form.settings">
            <a-checkbox value="is_required">{{ $t('report.field_setting_is_required') }}</a-checkbox>
            <a-checkbox value="is_uniq">{{ $t('report.field_setting_is_uniq') }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item :label="$t('report.field_min')" v-if="isNumber">
          <a-input-number v-model="form.min" :placeholder="$t('common.tips.input', [$t('report.field_min')])" style="width:50%" />
        </a-form-model-item>
        <a-form-model-item :label="$t('report.field_max')" v-if="isNumber">
          <a-input-number v-model="form.max" :placeholder="$t('common.tips.input', [$t('report.field_max')])" style="width:50%" />
        </a-form-model-item>
        <a-form-model-item :label="$t('report.unit')" v-if="isInt">
          <a-input v-model="form.unit" :placeholder="$t('common.tips.input', [$t('report.unit')])" style="width:50%" />
        </a-form-model-item>
        <a-form-model-item :label="$t('report.field_enume')" v-if="isEnume" class="mb-0" prop="enmue">
          <div class="d-flex mb-3" v-for="(item,index) in form.enume" :key="index">
            <a-input class="ml-2" v-model="item.name" :placeholder="$t('common.tips.input', [$t('report.field_enume')])" @change="checkValidate" />
            <div class="d-flex" style="flex: 0 0 80px">
              <a-button v-show="form.enume.length > 1" class="ml-1" type="link" icon="minus-circle" @click="handleDeleteEnume(index)" />
              <a-button v-show="index === form.enume.length - 1" class="ml-1" type="link" icon="plus-circle" @click="handleAddEnume" />
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'
import { FIELD_TYPES, FIELD_NAME_BLACKLIST } from '../constants'

export default {
  name: 'ResourceTypeCreateAttributeDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { name = '', unit = undefined, value_type = undefined, settings = [], max, min, enume = [] } = this.params.data || {}
    return {
      loading: false,
      form: {
        name,
        value_type,
        settings,
        max,
        min,
        enume,
        unit,
      },
      rules: {
        name: {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(this.$t('common.tips.input', [this.$t('report.field_name')]))
            } else if (this.params.attributes.some(item => item.name === this.form.name.trim())) {
              callback(this.$t('report.field_not_duplicated'))
            } else if (FIELD_NAME_BLACKLIST.includes(this.form.name.trim())) {
              callback(this.$t('report.field_name_blacklist'))
            }
            callback()
          },
        },
        value_type: { required: true, message: this.$t('common.tips.select', [this.$t('report.field_type')]) },
        enmue: {
          required: true,
          validator: (rule, value, callback) => {
            let multi = false
            this.form.enume.map((item, index) => {
              this.form.enume.map((item2, index2) => {
                if (index !== index2 && item.name === item2.name) {
                  multi = true
                }
              })
            })
            if (this.form.enume.some(item => !item.name) || multi) {
              callback(new Error(this.$t('report.field_enume_tip')))
            }
            callback()
          },
        },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      valueTypeOpts: FIELD_TYPES,
    }
  },
  computed: {
    isInt () {
      return this.form.value_type === '1'
    },
    isNumber () {
      return this.form.value_type === '1' || this.form.value_type === '2'
    },
    isEnume () {
      return this.form.value_type === '6'
    },
  },
  methods: {
    handleValueTypeChange (val) {
      if (val === '6') {
        if (!this.form.enume || !this.form.enume.length) {
          this.form.enume = [{ name: null }]
        }
      }
    },
    handleAddEnume () {
      this.form.enume.push({ name: null })
    },
    handleDeleteEnume (index) {
      this.form.enume = this.form.enume.filter((item, i) => i !== index)
    },
    checkValidate () {
      if (this.form.enume.every(item => item.name)) {
        this.$refs.form.validateField('enmue')
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        this.params.ok(this.form)
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
